import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const TREX_STYLE_ID = 'trex-easter-egg-styles';

const TREX_CSS = `
/* ========== BASE ========== */
.trex-ee{position:fixed;inset:0;z-index:99999;pointer-events:none;overflow:hidden}
.trex-ee-shaker{width:100%;height:100%;position:relative}
.trex-ee.phase-entrance .trex-ee-shaker,
.trex-ee.phase-eating .trex-ee-shaker{animation:_trShake .12s linear infinite}
.trex-ee.phase-retreat .trex-ee-shaker{animation:none}

/* ========== JAW OVERLAYS ========== */
.trex-ee-jaw{position:absolute;left:0;width:100%;height:52%;z-index:5;
  transition:transform .6s cubic-bezier(.68,-.55,.265,1.55)}
.trex-ee-jaw.top{top:0;transform:translateY(-105%);
  background:linear-gradient(180deg,#1a1a1a 80%,#2d0a0a)}
.trex-ee-jaw.bot{bottom:0;transform:translateY(105%);
  background:linear-gradient(0deg,#1a1a1a 80%,#2d0a0a)}
.trex-ee.phase-eating .trex-ee-jaw.top,
.trex-ee.phase-eating .trex-ee-jaw.bot{transform:translateY(0)}
.trex-ee.phase-retreat .trex-ee-jaw.top{transform:translateY(-105%);transition:transform .8s .3s ease-in}
.trex-ee.phase-retreat .trex-ee-jaw.bot{transform:translateY(105%);transition:transform .8s .3s ease-in}

/* Teeth on jaw overlays */
.trex-ee-teeth{position:absolute;left:3%;width:94%;height:40px}
.trex-ee-teeth.top{bottom:-2px;background:white;
  clip-path:polygon(0% 0%,4% 100%,8% 0%,12% 100%,16% 0%,20% 100%,24% 0%,28% 100%,
    32% 0%,36% 100%,40% 0%,44% 100%,48% 0%,52% 100%,56% 0%,60% 100%,
    64% 0%,68% 100%,72% 0%,76% 100%,80% 0%,84% 100%,88% 0%,92% 100%,96% 0%,100% 0%)}
.trex-ee-teeth.bot{top:-2px;background:white;
  clip-path:polygon(0% 100%,4% 0%,8% 100%,12% 0%,16% 100%,20% 0%,24% 100%,28% 0%,
    32% 100%,36% 0%,40% 100%,44% 0%,48% 100%,52% 0%,56% 100%,60% 0%,
    64% 100%,68% 0%,72% 100%,76% 0%,80% 100%,84% 0%,88% 100%,92% 0%,96% 100%,100% 100%)}

/* Red mouth tint */
.trex-ee-tint{position:absolute;inset:0;z-index:6;opacity:0;
  background:radial-gradient(ellipse at 50% 60%,rgba(180,20,20,.35),rgba(40,0,0,.65));
  transition:opacity .4s}
.trex-ee.phase-eating .trex-ee-tint{opacity:1;transition-delay:.5s}
.trex-ee.phase-retreat .trex-ee-tint{opacity:0;transition-delay:0s}

/* ========== SCREEN CRACKS ========== */
.trex-ee-cracks{position:absolute;inset:0;width:100%;height:100%;z-index:7;opacity:0}
.trex-ee-cracks path{fill:none;stroke:rgba(255,255,255,.7);stroke-width:.4;
  stroke-dasharray:100;stroke-dashoffset:100}
.trex-ee.phase-eating .trex-ee-cracks{opacity:1}
.trex-ee.phase-eating .trex-ee-cracks path{animation:_trCrack 1.2s .4s forwards}
.trex-ee.phase-retreat .trex-ee-cracks{opacity:0;transition:opacity .3s}

/* ========== T-REX CHARACTER ========== */
.trex-ee-pos{position:absolute;bottom:0;left:50%;transform:translateX(-50%) translateY(110%);z-index:10}
.trex-ee.phase-entrance .trex-ee-pos{animation:_trBounceUp 1.4s cubic-bezier(.34,1.56,.64,1) forwards}
.trex-ee.phase-eating .trex-ee-pos{transform:translateX(-50%) translateY(0)}
.trex-ee.phase-retreat .trex-ee-pos{animation:_trRetreat 1.8s .2s ease-in-out forwards}
.trex-ee-body{transform-origin:center bottom}
.trex-ee.phase-eating .trex-ee-body{animation:_trWobble .35s ease-in-out infinite}
.trex-ee.phase-retreat .trex-ee-body{animation:_trWiggle 1.2s ease-in-out}

/* SVG part animations */
.trex-ee-svg-jaw{transform-origin:100px 82px}
.trex-ee.phase-eating .trex-ee-svg-jaw{animation:_trChomp .35s ease-in-out infinite}
.trex-ee-svg-pupil-l{animation:_trGoogly1 .55s ease-in-out infinite}
.trex-ee-svg-pupil-r{animation:_trGoogly2 .5s ease-in-out infinite}
.trex-ee-svg-arm-l{transform-origin:68px 128px;animation:_trArmL .25s ease-in-out infinite}
.trex-ee-svg-arm-r{transform-origin:132px 128px;animation:_trArmR .28s ease-in-out infinite}
.trex-ee-svg-tail{transform-origin:40px 135px;animation:_trTailWag .4s ease-in-out infinite}

/* ========== COMIC TEXT ========== */
.trex-ee-text{position:absolute;z-index:20;
  font-family:Impact,'Arial Black',sans-serif;font-weight:900;font-style:italic;
  color:white;-webkit-text-stroke:3px #333;paint-order:stroke fill;
  letter-spacing:2px;pointer-events:none;user-select:none}

.trex-ee-stomp1{font-size:52px;bottom:28%;left:12%;color:#FF6B35;-webkit-text-stroke-color:#8B2500;
  animation:_trTextPop .45s .7s both,_trTextFade .35s 1.2s both;
  text-shadow:3px 3px 0 #8B2500,0 0 20px rgba(255,107,53,.5)}
.trex-ee-stomp2{font-size:46px;bottom:22%;right:10%;color:#FF6B35;-webkit-text-stroke-color:#8B2500;
  animation:_trTextPop .45s 1s both,_trTextFade .35s 1.35s both;
  text-shadow:3px 3px 0 #8B2500,0 0 20px rgba(255,107,53,.5)}
.trex-ee-chomp{font-size:72px;top:15%;left:0;right:0;text-align:center;color:#FF1744;
  -webkit-text-stroke-color:#7f0000;
  animation:_trTextPop .5s .15s both,_trTextFade .4s 1.1s both;
  text-shadow:4px 4px 0 #7f0000,0 0 30px rgba(255,23,68,.6)}
.trex-ee-nom{font-size:56px;top:38%;left:0;right:0;text-align:center;color:#FFAB00;
  -webkit-text-stroke-color:#7f5600;
  animation:_trTextPop .5s .7s both,_trTextFade .4s 1.5s both;
  text-shadow:3px 3px 0 #7f5600,0 0 25px rgba(255,171,0,.5)}
.trex-ee-burp{font-size:58px;bottom:48%;left:0;right:0;text-align:center;color:#76FF03;
  -webkit-text-stroke-color:#2E7D32;
  animation:_trTextPop .55s .2s both,_trBurpFade 1.2s .8s both;
  text-shadow:3px 3px 0 #2E7D32,0 0 25px rgba(118,255,3,.5)}

/* ========== PARTICLES ========== */
.trex-ee-star{position:absolute;z-index:8;font-size:45px;animation:_trStarBurst .7s both}
.trex-ee-heart{position:absolute;z-index:12;font-size:30px;animation:_trHeartFloat 1.6s both}
.trex-ee-note{position:absolute;z-index:12;font-size:28px;color:#FFD700;
  font-weight:bold;animation:_trNoteFloat 1.4s both;
  text-shadow:0 0 10px rgba(255,215,0,.6)}
.trex-ee-puff{position:absolute;z-index:12;font-size:36px;animation:_trPuffFloat 1.2s both}
.trex-ee-impact{position:absolute;z-index:8;width:60px;height:4px;
  background:white;border-radius:2px;transform-origin:left center;animation:_trImpactLine .5s both}

/* ========== KEYFRAMES ========== */
@keyframes _trShake{
  0%,100%{transform:translate(0,0) rotate(0)}
  10%{transform:translate(-5px,3px) rotate(-.5deg)}
  30%{transform:translate(5px,-4px) rotate(.5deg)}
  50%{transform:translate(-4px,-3px) rotate(-.3deg)}
  70%{transform:translate(4px,4px) rotate(.4deg)}
  90%{transform:translate(-3px,2px) rotate(-.2deg)}}
@keyframes _trBounceUp{
  0%{transform:translateX(-50%) translateY(110%)}
  55%{transform:translateX(-50%) translateY(-10%)}
  72%{transform:translateX(-50%) translateY(4%)}
  86%{transform:translateX(-50%) translateY(-2%)}
  100%{transform:translateX(-50%) translateY(0)}}
@keyframes _trRetreat{
  0%{transform:translateX(-50%) translateY(0)}
  15%{transform:translateX(-50%) translateY(-8%)}
  100%{transform:translateX(-50%) translateY(115%)}}
@keyframes _trWobble{
  0%,100%{transform:rotate(-1.5deg) scaleY(1)}
  25%{transform:rotate(1deg) scaleY(1.03)}
  50%{transform:rotate(1.5deg) scaleY(.97)}
  75%{transform:rotate(-1deg) scaleY(1.02)}}
@keyframes _trWiggle{
  0%,100%{transform:rotate(0) translateX(0)}
  10%{transform:rotate(-7deg) translateX(-14px)}
  20%{transform:rotate(7deg) translateX(14px)}
  30%{transform:rotate(-6deg) translateX(-12px)}
  40%{transform:rotate(6deg) translateX(12px)}
  50%{transform:rotate(-4deg) translateX(-8px)}
  60%{transform:rotate(4deg) translateX(8px)}
  70%{transform:rotate(-2deg) translateX(-4px)}
  80%{transform:rotate(2deg) translateX(4px)}}
@keyframes _trChomp{
  0%,100%{transform:rotate(0deg) translateY(0)}
  35%{transform:rotate(22deg) translateY(4px)}
  50%{transform:rotate(22deg) translateY(4px)}
  85%{transform:rotate(0deg) translateY(0)}}
@keyframes _trGoogly1{
  0%,100%{transform:translate(0,0)}
  20%{transform:translate(-5px,3px)}
  45%{transform:translate(4px,-3px)}
  70%{transform:translate(-3px,-4px)}}
@keyframes _trGoogly2{
  0%,100%{transform:translate(0,0)}
  25%{transform:translate(4px,-4px)}
  50%{transform:translate(-5px,2px)}
  75%{transform:translate(3px,4px)}}
@keyframes _trArmL{
  0%,100%{transform:rotate(-30deg)}
  50%{transform:rotate(20deg)}}
@keyframes _trArmR{
  0%,100%{transform:rotate(30deg)}
  50%{transform:rotate(-20deg)}}
@keyframes _trTailWag{
  0%,100%{transform:rotate(-4deg)}
  50%{transform:rotate(4deg)}}
@keyframes _trTextPop{
  0%{transform:scale(0) rotate(-20deg);opacity:0}
  40%{transform:scale(1.5) rotate(8deg);opacity:1}
  65%{transform:scale(.85) rotate(-4deg);opacity:1}
  80%{transform:scale(1.15) rotate(2deg);opacity:1}
  100%{transform:scale(1) rotate(0);opacity:1}}
@keyframes _trTextFade{
  0%{opacity:1;transform:scale(1)}
  100%{opacity:0;transform:scale(.2) translateY(-50px)}}
@keyframes _trBurpFade{
  0%{opacity:1;transform:scale(1)}
  100%{opacity:0;transform:scale(1.6) translateY(-50px)}}
@keyframes _trStarBurst{
  0%{transform:scale(0) rotate(0);opacity:1}
  50%{transform:scale(1.8) rotate(180deg);opacity:.8}
  100%{transform:scale(2.5) rotate(360deg);opacity:0}}
@keyframes _trHeartFloat{
  0%{transform:scale(0) translateY(0);opacity:0}
  15%{transform:scale(1.4) translateY(-10px);opacity:1}
  40%{transform:scale(1) translateY(-50px);opacity:1}
  100%{transform:scale(.3) translateY(-150px);opacity:0}}
@keyframes _trNoteFloat{
  0%{transform:translateY(0) rotate(-10deg) scale(0);opacity:0}
  15%{transform:translateY(-5px) rotate(-5deg) scale(1.2);opacity:1}
  100%{transform:translateY(-100px) rotate(20deg) scale(.6);opacity:0}}
@keyframes _trPuffFloat{
  0%{transform:scale(0) translateY(0);opacity:0}
  25%{transform:scale(1.3) translateY(-5px);opacity:.7}
  100%{transform:scale(2) translateY(-40px) translateX(25px);opacity:0}}
@keyframes _trCrack{
  0%{stroke-dashoffset:100;opacity:0}
  20%{opacity:.9}
  100%{stroke-dashoffset:0;opacity:.7}}
@keyframes _trImpactLine{
  0%{transform:scaleX(0);opacity:1}
  60%{transform:scaleX(1);opacity:.7}
  100%{transform:scaleX(1.3);opacity:0}}
`;

export default function TRexAnimation({ onComplete }) {
    const [phase, setPhase] = useState('entrance');

    useEffect(() => {
        let styleEl = document.getElementById(TREX_STYLE_ID);
        if (!styleEl) {
            styleEl = document.createElement('style');
            styleEl.id = TREX_STYLE_ID;
            styleEl.textContent = TREX_CSS;
            document.head.appendChild(styleEl);
        }

        const timers = [
            setTimeout(() => setPhase('eating'), 1500),
            setTimeout(() => setPhase('retreat'), 3500),
            setTimeout(onComplete, 5500),
        ];

        return () => {
            timers.forEach(clearTimeout);
            const el = document.getElementById(TREX_STYLE_ID);
            if (el) el.remove();
        };
    }, [onComplete]);

    return createPortal(
        <div className={`trex-ee phase-${phase}`}>
            <div className="trex-ee-shaker">
                {/* Jaw overlays */}
                <div className="trex-ee-jaw top"><div className="trex-ee-teeth top" /></div>
                <div className="trex-ee-jaw bot"><div className="trex-ee-teeth bot" /></div>

                {/* Red mouth tint */}
                <div className="trex-ee-tint" />

                {/* Screen cracks */}
                <svg className="trex-ee-cracks" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <path d="M50,0 L48,15 L53,28 L46,42 L52,58 L47,72 L50,100" />
                    <path d="M28,0 L33,12 L26,26 L32,40" />
                    <path d="M72,0 L67,14 L74,28 L69,42" />
                    <path d="M0,45 L18,48 L32,42 L50,47" />
                    <path d="M100,55 L82,52 L68,58 L50,53" />
                    <path d="M15,100 L22,82 L18,68" />
                    <path d="M85,100 L78,84 L82,70" />
                </svg>
            </div>

            {/* === COMIC TEXT === */}
            {phase === 'entrance' && (
                <>
                    <div className="trex-ee-text trex-ee-stomp1">STOMP!</div>
                    <div className="trex-ee-text trex-ee-stomp2">STOMP!</div>
                </>
            )}
            {phase === 'eating' && (
                <>
                    <div className="trex-ee-text trex-ee-chomp">CHOMP!</div>
                    <div className="trex-ee-text trex-ee-nom">NOM NOM!</div>
                </>
            )}
            {phase === 'retreat' && (
                <div className="trex-ee-text trex-ee-burp">*BURRRP!*</div>
            )}

            {/* === IMPACT STARS (entrance) === */}
            {phase === 'entrance' && (
                <>
                    <div className="trex-ee-star" style={{left:'30%',bottom:'8%',animationDelay:'.75s'}}>💥</div>
                    <div className="trex-ee-star" style={{left:'62%',bottom:'10%',animationDelay:'1s'}}>💥</div>
                    <div className="trex-ee-star" style={{left:'20%',bottom:'4%',animationDelay:'1.15s'}}>⭐</div>
                    <div className="trex-ee-star" style={{left:'72%',bottom:'6%',animationDelay:'1.25s'}}>⭐</div>
                    {/* Impact speed lines */}
                    <div className="trex-ee-impact" style={{left:'15%',bottom:'12%',transform:'rotate(-25deg)',animationDelay:'.8s'}} />
                    <div className="trex-ee-impact" style={{right:'18%',bottom:'14%',transform:'rotate(25deg)',animationDelay:'1.05s'}} />
                </>
            )}

            {/* === HEARTS + NOTES + PUFFS (retreat) === */}
            {phase === 'retreat' && (
                <>
                    <div className="trex-ee-heart" style={{left:'42%',bottom:'38%',animationDelay:'0s'}}>❤️</div>
                    <div className="trex-ee-heart" style={{left:'50%',bottom:'36%',animationDelay:'.2s'}}>💚</div>
                    <div className="trex-ee-heart" style={{left:'57%',bottom:'38%',animationDelay:'.4s'}}>❤️</div>
                    <div className="trex-ee-note" style={{left:'38%',bottom:'33%',animationDelay:'.3s'}}>♪</div>
                    <div className="trex-ee-note" style={{left:'60%',bottom:'35%',animationDelay:'.6s'}}>♫</div>
                    <div className="trex-ee-note" style={{left:'48%',bottom:'30%',animationDelay:'.8s'}}>♪</div>
                    <div className="trex-ee-puff" style={{left:'55%',bottom:'32%',animationDelay:'.15s'}}>💨</div>
                </>
            )}

            {/* === T-REX CHARACTER === */}
            <div className="trex-ee-pos">
                <div className="trex-ee-body">
                    <svg viewBox="0 0 200 240" width="220" height="264" xmlns="http://www.w3.org/2000/svg">
                        {/* Tail */}
                        <path className="trex-ee-svg-tail"
                            d="M 32,140 Q 8,125 6,100 Q 5,85 18,82"
                            fill="#4CAF50" stroke="#2E7D32" strokeWidth="3" strokeLinecap="round" />
                        <path d="M 10,98 Q 3,90 8,82" fill="none" stroke="#2E7D32" strokeWidth="2.5" strokeLinecap="round" />

                        {/* Body */}
                        <ellipse cx="100" cy="148" rx="56" ry="62" fill="#4CAF50" stroke="#2E7D32" strokeWidth="3" />
                        {/* Belly */}
                        <ellipse cx="100" cy="163" rx="36" ry="42" fill="#81C784" />
                        {/* Body spots */}
                        <circle cx="68" cy="128" r="7" fill="#43A047" opacity=".45" />
                        <circle cx="130" cy="132" r="8" fill="#43A047" opacity=".4" />
                        <circle cx="72" cy="165" r="5.5" fill="#43A047" opacity=".35" />
                        <circle cx="128" cy="168" r="6" fill="#43A047" opacity=".35" />
                        <circle cx="100" cy="120" r="4" fill="#43A047" opacity=".3" />

                        {/* Legs */}
                        <rect x="66" y="200" width="20" height="28" rx="9" fill="#4CAF50" stroke="#2E7D32" strokeWidth="2.5" />
                        <rect x="114" y="200" width="20" height="28" rx="9" fill="#4CAF50" stroke="#2E7D32" strokeWidth="2.5" />
                        {/* Feet */}
                        <ellipse cx="76" cy="230" rx="16" ry="8" fill="#4CAF50" stroke="#2E7D32" strokeWidth="2" />
                        <ellipse cx="124" cy="230" rx="16" ry="8" fill="#4CAF50" stroke="#2E7D32" strokeWidth="2" />
                        {/* Toes */}
                        <circle cx="64" cy="233" r="3.5" fill="#388E3C" />
                        <circle cx="76" cy="236" r="3.5" fill="#388E3C" />
                        <circle cx="88" cy="233" r="3.5" fill="#388E3C" />
                        <circle cx="112" cy="233" r="3.5" fill="#388E3C" />
                        <circle cx="124" cy="236" r="3.5" fill="#388E3C" />
                        <circle cx="136" cy="233" r="3.5" fill="#388E3C" />

                        {/* Arms (comically tiny!) */}
                        <g className="trex-ee-svg-arm-l">
                            <path d="M 68,128 L 48,116 L 40,108" fill="none" stroke="#4CAF50" strokeWidth="7" strokeLinecap="round" />
                            <circle cx="38" cy="106" r="4.5" fill="#66BB6A" stroke="#2E7D32" strokeWidth="1.5" />
                            {/* Tiny fingers */}
                            <line x1="36" y1="103" x2="33" y2="100" stroke="#2E7D32" strokeWidth="1.5" strokeLinecap="round" />
                            <line x1="38" y1="102" x2="37" y2="98" stroke="#2E7D32" strokeWidth="1.5" strokeLinecap="round" />
                        </g>
                        <g className="trex-ee-svg-arm-r">
                            <path d="M 132,128 L 152,116 L 160,108" fill="none" stroke="#4CAF50" strokeWidth="7" strokeLinecap="round" />
                            <circle cx="162" cy="106" r="4.5" fill="#66BB6A" stroke="#2E7D32" strokeWidth="1.5" />
                            <line x1="164" y1="103" x2="167" y2="100" stroke="#2E7D32" strokeWidth="1.5" strokeLinecap="round" />
                            <line x1="162" y1="102" x2="163" y2="98" stroke="#2E7D32" strokeWidth="1.5" strokeLinecap="round" />
                        </g>

                        {/* Neck */}
                        <rect x="82" y="82" width="36" height="32" rx="12" fill="#4CAF50" />

                        {/* Head */}
                        <g className="trex-ee-svg-head">
                            {/* Skull */}
                            <ellipse cx="100" cy="52" rx="44" ry="40" fill="#4CAF50" stroke="#2E7D32" strokeWidth="3" />
                            {/* Snout / upper jaw */}
                            <ellipse cx="100" cy="74" rx="30" ry="17" fill="#4CAF50" stroke="#2E7D32" strokeWidth="2.5" />
                            {/* Nostrils */}
                            <ellipse cx="88" cy="66" rx="3.5" ry="2.5" fill="#2E7D32" />
                            <ellipse cx="112" cy="66" rx="3.5" ry="2.5" fill="#2E7D32" />
                            {/* Upper teeth */}
                            <polygon points="76,84 80,95 84,84" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                            <polygon points="85,86 89,97 93,86" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                            <polygon points="95,87 99,98 103,87" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                            <polygon points="105,86 109,97 113,86" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                            <polygon points="114,84 118,95 122,84" fill="white" stroke="#e0e0e0" strokeWidth=".5" />

                            {/* Lower jaw (animated) */}
                            <g className="trex-ee-svg-jaw">
                                <ellipse cx="100" cy="93" rx="26" ry="13" fill="#66BB6A" stroke="#2E7D32" strokeWidth="2.5" />
                                {/* Lower teeth */}
                                <polygon points="80,88 83,79 86,88" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                                <polygon points="88,87 91,77 94,87" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                                <polygon points="96,87 99,77 102,87" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                                <polygon points="104,87 107,77 110,87" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                                <polygon points="112,88 115,79 118,88" fill="white" stroke="#e0e0e0" strokeWidth=".5" />
                                {/* Tongue */}
                                <ellipse cx="100" cy="93" rx="12" ry="6" fill="#E57373" opacity=".85" />
                            </g>

                            {/* Brow ridges */}
                            <path d="M 62,30 Q 72,18 84,28" fill="none" stroke="#2E7D32" strokeWidth="4" strokeLinecap="round" />
                            <path d="M 138,30 Q 128,18 116,28" fill="none" stroke="#2E7D32" strokeWidth="4" strokeLinecap="round" />

                            {/* Left eye */}
                            <g className="trex-ee-svg-eye-l">
                                <circle cx="78" cy="42" r="15" fill="white" stroke="#2E7D32" strokeWidth="2.5" />
                                <circle className="trex-ee-svg-pupil-l" cx="82" cy="43" r="7.5" fill="#1a1a1a" />
                                <circle cx="86" cy="38" r="3" fill="white" opacity=".9" />
                            </g>
                            {/* Right eye */}
                            <g className="trex-ee-svg-eye-r">
                                <circle cx="122" cy="42" r="15" fill="white" stroke="#2E7D32" strokeWidth="2.5" />
                                <circle className="trex-ee-svg-pupil-r" cx="118" cy="43" r="7.5" fill="#1a1a1a" />
                                <circle cx="122" cy="38" r="3" fill="white" opacity=".9" />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>,
        document.body
    );
}
